import axios from "axios";
import config from "../config";

// Meetings recorded by the Sidekick desktop and mobile apps. The API only ever
// returns the signed-in user's own meetings.

export function getMeetings(params) {
  return axios.get(`${config.api_url}/meetings`, { params });
}

export function getMeeting(sqid) {
  return axios.get(`${config.api_url}/meetings/${sqid}`, {
    params: { hydrate: 1 },
  });
}

// title and/or user_notes
export function updateMeeting(sqid, data) {
  return axios.patch(`${config.api_url}/meetings/${sqid}`, data);
}

export function deleteMeeting(sqid) {
  return axios.delete(`${config.api_url}/meetings/${sqid}`);
}

export function askMeeting(sqid, question) {
  return axios.post(`${config.api_url}/meetings/${sqid}/query`, { question });
}

// Leaving templateId undefined keeps the meeting's own template; null means
// the built-in one. 409 cannot_summarise unless the meeting is PROCESSED.
export function summariseMeeting(sqid, templateId) {
  return axios.post(
    `${config.api_url}/meetings/${sqid}/summarise`,
    templateId === undefined ? {} : { meeting_notes_template_id: templateId },
  );
}

// 422 code no_summary until there's a summary to send
export function emailMeeting(sqid, emails) {
  return axios.post(`${config.api_url}/meetings/${sqid}/email`, { emails });
}

// change is "all" or the index of a single turn
export function renameMeetingParticipant(sqid, original, name, change) {
  return axios.patch(`${config.api_url}/meetings/${sqid}/participant-name`, {
    original_value: original,
    new_value: name,
    change: String(change),
  });
}
